import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

// TODO: Google Tag Manager

function IconCard({ icon, titleId, descriptionId, linkTextId, linkUrl }) {
  return (
    <Styled.CardBody>
      <Styled.IconColumn>{icon}</Styled.IconColumn>
      <Styled.DescriptionColumn>
        <Styled.Title>
          <FormattedMessage id={titleId} />
        </Styled.Title>
        <Styled.Description>
          <FormattedMessage id={descriptionId} />
        </Styled.Description>
        <Styled.LinkRow>
          <Styled.CardLink href={linkUrl} target="_blank">
            <Styled.LinkSpan>
              <FormattedMessage id={linkTextId} />
            </Styled.LinkSpan>
            <Styled.ExternalLinkIcon />
          </Styled.CardLink>
        </Styled.LinkRow>
      </Styled.DescriptionColumn>
    </Styled.CardBody>
  );
}

IconCard.propTypes = {
  /** Card icon */
  icon: PropTypes.element.isRequired,
  /** Card title message id */
  titleId: PropTypes.string.isRequired,
  /** Card description message od */
  descriptionId: PropTypes.string.isRequired,
  /** Link text message id */
  linkTextId: PropTypes.string.isRequired,
  /** Link Url */
  linkUrl: PropTypes.string.isRequired,
};

export default IconCard;
